// Real SVG tech logos — mixed sources for reliability.
// simpleicons.org for most monochrome; devicon for AWS (simpleicons removed trademarked logos).

const SI = (slug) => `https://cdn.simpleicons.org/${slug}/A1A1AA`;
const DEVICON = (path) => `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/${path}.svg`;

export const TECH_STACK = [
  { name: "React",        icon: SI("react") },
  { name: "Next.js",      icon: SI("nextdotjs") },
  { name: "TypeScript",   icon: SI("typescript") },
  { name: "Node.js",      icon: SI("nodedotjs") },
  { name: "Python",       icon: SI("python") },
  { name: "PHP",          icon: SI("php") },
  { name: "Laravel",      icon: SI("laravel") },
  { name: "WordPress",    icon: SI("wordpress") },
  { name: "PostgreSQL",   icon: SI("postgresql") },
  { name: "MySQL",        icon: SI("mysql") },
  { name: "MongoDB",      icon: SI("mongodb") },
  { name: "Docker",       icon: SI("docker") },
  { name: "Linux",        icon: SI("linux") },
  // AWS: simpleicons removed trademarked logo — use devicon plain-wordmark
  { name: "AWS",          icon: DEVICON("amazonwebservices/amazonwebservices-plain-wordmark"), wide: true },
  { name: "Tailwind",     icon: SI("tailwindcss") },
  { name: "Solidity",     icon: SI("solidity") },
  { name: "Ethereum",     icon: SI("ethereum") },
  { name: "GraphQL",      icon: SI("graphql") },
];

// Trusted-by partner logos
export const PARTNER_LOGOS = [
  { name: "Vercel",     icon: SI("vercel") },
  { name: "Stripe",     icon: SI("stripe") },
  { name: "GitHub",     icon: SI("github") },
  { name: "Cloudflare", icon: SI("cloudflare") },
  { name: "Figma",      icon: SI("figma") },
  { name: "Notion",     icon: SI("notion") },
  // Replacements for simpleicons removals (Slack/OpenAI 404):
  { name: "Slack",      icon: DEVICON("slack/slack-original") },
  { name: "Anthropic",  icon: SI("anthropic") },
  { name: "Discord",    icon: SI("discord") },
  { name: "X",          icon: SI("x") },
];
